import React from 'react';
import { Feed } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/views/feed.less';

export default Feed;
